import "neuroglancer";
import { setupDefaultViewer } from "neuroglancer/unstable/ui/default_viewer_setup.js";
import { createPinia } from "pinia";
import { createApp, nextTick } from "vue";
import App from "#src/components/App.vue";
import { loaded, useLayersStore, useVolumesStore } from "#src/store.js";
import { useStatsStore } from "#src/store-pyr.js";

const newState = location.hash === "";

function mergeTopBars() {
  const ngTopBar = document.querySelector(".neuroglancer-viewer")!.children[0];
  const topBarVueParent = document.getElementById("insertNGTopBar")!;
  topBarVueParent.appendChild(ngTopBar);
}

window.addEventListener("DOMContentLoaded", () => {
  const pinia = createPinia();
  const app = createApp(App);
  app.use(pinia);
  const { initializeWithViewer } = useLayersStore();
  app.directive("visible", function (el, binding) {
    el.style.visibility = !!binding.value ? "visible" : "hidden";
  });
  app.mount("#app");
  const viewer = setupDefaultViewer();
  if (newState) {
    setTimeout(() => {
      viewer.layout.container.setSpecification("xy-3d");
    }, 0);
  }
  initializeWithViewer(viewer);
  const { loadVolumes } = useVolumesStore();
  loadVolumes(viewer);
  loaded.value = true;

  nextTick(() => {
    // need to wait for loaded to be applied
    mergeTopBars();
  });

  const { loopUpdateLeaderboard } = useStatsStore();
  loopUpdateLeaderboard();
});
